import { PostReviewPresenter } from '@/presentation/presenters/reviewPost/postReviewPresenter'
import { PostReviewViewModel } from '@/presentation/viewmodels/reviewPost/postReviewViewModel'

export function usePostReviewPresenter(
  presenter: PostReviewPresenter = new PostReviewPresenter(new PostReviewViewModel())
) {
  return {
    reviewList: presenter.reviewList,
    isLoading: presenter.isLoading,
    error: presenter.error,
    setReview: presenter.setReview.bind(presenter),
    postReview: presenter.postReview.bind(presenter)
  }
}
